import Checkout from './Checkout';
import checkoutSlice from './checkoutSlice';
import { paymentMethodsSlice } from '../common/Payment/components/PaymentMethods';
import { paymentOptionsSlice } from '../common/Payment/components/PaymentOptions';
import { offerSlice } from '../common/Offers';
import make3dsSlice from '../common/Make3ds/make3dsSlice';
import passPortWidgetsSlice from '../common/passportWidgets/passPortWidgetsSlice';

const sliceReducers = {
  mainStateData: checkoutSlice,
  paymentMethods: paymentMethodsSlice,
  paymentOptions: paymentOptionsSlice,
  offersData: offerSlice,
  make3ds: make3dsSlice,
  passPortWidgets: passPortWidgetsSlice,
};

export { sliceReducers };
export default Checkout;
